var render = function render(){var _vm=this,_c=_vm._self._c;return _c('step-choice',{attrs:{"tab-class":"tab-code","headline":"Haben Sie bereits einen Freischaltcode Ihrer Krankenkasse für Vitadio?","options":_vm.options},on:{"answer":function($event){return _vm.$emit('answer', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }